export const categories = [
  {
    id: 1,
    name: "Women's Boutique Collection",
    label: "Women's Wear",
    tag: 'Best Seller',
    image: 'https://images.pexels.com/photos/4507154/pexels-photo-4507154.jpeg?auto=compress&cs=tinysrgb&w=600',
    moq: '50 Pieces',
  },
  {
    id: 2,
    name: "Men's Wholesale Collection",
    label: "Men's Wear",
    tag: 'Bulk Available',
    image: 'https://images.unsplash.com/photo-1611312449408-fcece27cdbb7?w=600&q=80',
    moq: '50 Pieces',
  },
  {
    id: 3,
    name: 'Ethnic Wear Collection',
    label: 'Ethnic Wear',
    tag: 'New Arrival',
    image: 'https://images.pexels.com/photos/33959044/pexels-photo-33959044.jpeg?auto=compress&cs=tinysrgb&w=600',
    moq: '25 Pieces',
  },
  {
    id: 4,
    name: 'Kids Bulk Collection',
    label: "Kids' Wear",
    tag: 'Bulk Available',
    image: 'https://images.unsplash.com/photo-1627639679638-8485316a4b21?w=600&q=80',
    moq: '100 Pieces',
  },
];

export const products = [
  {
    id: 1,
    sku: 'WLD-2026-001',
    collection: 'Summer Florals',
    category: "Women's Wear",
    badge: 'Best Seller',
    image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&q=80',
  },
  {
    id: 2,
    sku: 'WLD-2026-002',
    collection: 'Casual Everyday',
    category: "Men's Wear",
    badge: 'New Arrival',
    image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=400&q=80',
  },
  {
    id: 3,
    sku: 'ETH-2026-003',
    collection: 'Festive Ethnic',
    category: 'Ethnic Wear',
    badge: 'Hot',
    image: 'https://images.pexels.com/photos/33959044/pexels-photo-33959044.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 4,
    sku: 'KDS-2026-004',
    collection: 'Young Trendsetter',
    category: "Kids' Wear",
    badge: 'Bulk Available',
    image: 'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=400&q=80',
  },
  {
    id: 5,
    sku: 'WLD-2026-005',
    collection: 'Western Chic',
    category: "Women's Wear",
    badge: 'Best Seller',
    image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=400&q=80',
  },
  {
    id: 6,
    sku: 'MEN-2026-006',
    collection: 'Smart Casual',
    category: "Men's Wear",
    badge: 'New Arrival',
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=80',
  },
  {
    id: 7,
    sku: 'ETH-2026-007',
    collection: 'Zari Embroidered',
    category: 'Ethnic Wear',
    badge: 'Hot',
    image: 'https://images.pexels.com/photos/4507154/pexels-photo-4507154.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 8,
    sku: 'KDS-2026-008',
    collection: 'Fun & Bright',
    category: "Kids' Wear",
    badge: 'Bulk Available',
    image: 'https://images.unsplash.com/photo-1627639679638-8485316a4b21?w=400&q=80',
  },
];

export const testimonials = [
  {
    id: 1,
    rating: 5,
    review: "The quality of the Rayon and Cotton fabrics is exceptional. We've been sourcing for our Ahmedabad showrooms for 2 years. Their 24-hour dispatch is a lifesaver during festive seasons.",
    name: 'Anjali Verma',
    role: 'Showroom Owner, Ahmedabad',
    avatar: 'https://ui-avatars.com/api/?name=Anjali+Verma&background=C9A14A&color=fff&bold=true',
  },
  {
    id: 2,
    rating: 5,
    review: "Switching to Anapurna Sales helped us improve our retail margins by 20%. Factory-direct pricing without the hassle of middlemen. Their WhatsApp support for bulk orders is very responsive.",
    name: 'Rajesh Khanna',
    role: 'Wholesale Dealer, Surat',
    avatar: 'https://ui-avatars.com/api/?name=Rajesh+Khanna&background=0B0F19&color=fff&bold=true',
  },
  {
    id: 3,
    rating: 5,
    review: "Highly trend-driven collections. The MOQ of 50 pieces allows us to test new styles across our retail chain before committing to larger inventories. On-time delivery every single time.",
    name: 'Manoj Singhania',
    role: 'Retail Chain Manager, Indore',
    avatar: 'https://ui-avatars.com/api/?name=Manoj+Singhania&background=C9A14A&color=fff&bold=true',
  },
  {
    id: 4,
    rating: 5,
    review: "As a boutique owner in Kerala, I was worried about shipping times, but Anapurna's logistics partners are incredibly reliable. The packaging is always secure and professional.",
    name: 'Lakshmi Menon',
    role: 'Boutique Owner, Kochi',
    avatar: 'https://ui-avatars.com/api/?name=Lakshmi+Menon&background=0B0F19&color=fff&bold=true',
  },
  {
    id: 5,
    rating: 5,
    review: "The variety of ethnic wear is unmatched. We sourcing for over 5 outlets and the consistency in fabric quality across bulk batches is what keeps us coming back.",
    name: 'Vikram Seth',
    role: 'Director, Ethnic Hub',
    avatar: 'https://ui-avatars.com/api/?name=Vikram+Seth&background=C9A14A&color=fff&bold=true',
  },
  {
    id: 6,
    rating: 5,
    review: "Their digital catalogue is a game changer for resellers. I can show designs to my clients before even placing my bulk order. Transparency in pricing is a big plus.",
    name: 'Deepika Rao',
    role: 'Independent Reseller, Mumbai',
    avatar: 'https://ui-avatars.com/api/?name=Deepika+Rao&background=0B0F19&color=fff&bold=true',
  },
  {
    id: 7,
    rating: 5,
    review: "Great experience with their dedicated account manager. They helped us curate a collection specifically for our local market's taste. Highly personalized service for B2B.",
    name: 'Suresh Bhatia',
    role: 'Owner, Bhatia Garments',
    avatar: 'https://ui-avatars.com/api/?name=Suresh+Bhatia&background=C9A14A&color=fff&bold=true',
  },
  {
    id: 8,
    rating: 5,
    review: "For anyone looking to scale their clothing business, Anapurna is the right partner. Their bulk availability and inventory depth are superior to what we found in local markets.",
    name: 'Rahul Dua',
    role: 'Operations Head, Fashion Ltd',
    avatar: 'https://ui-avatars.com/api/?name=Rahul+Dua&background=0B0F19&color=fff&bold=true',
  },
];

export const galleryImages = [
  {
    id: 1,
    image: 'https://images.pexels.com/photos/25987916/pexels-photo-25987916.jpeg?auto=compress&cs=tinysrgb&w=500',
    alt: 'Wholesale fashion collection 1',
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1539684371066-9079b087853b?w=500&q=80',
    alt: 'Wholesale fashion collection 2',
  },
  {
    id: 3,
    image: 'https://images.pexels.com/photos/7324786/pexels-photo-7324786.jpeg?auto=compress&cs=tinysrgb&w=500',
    alt: 'Wholesale fashion collection 3',
  },
  {
    id: 4,
    image: 'https://images.pexels.com/photos/29242228/pexels-photo-29242228.jpeg?auto=compress&cs=tinysrgb&w=500',
    alt: 'Wholesale fashion collection 4',
  },
];

export const valuePropositions = [
  {
    id: 1,
    icon: 'Factory',
    title: 'Factory Direct Pricing',
    description: 'Source directly from manufacturers — no middlemen. Maximize your margins.',
  },
  {
    id: 2,
    icon: 'TrendingUp',
    title: 'Latest Trending Designs',
    description: 'New collections every season. Stock what sells — backed by retail trend data.',
  },
  {
    id: 3,
    icon: 'Package',
    title: 'Low Minimum Order',
    description: 'Start from just 50 pieces per style. Scale as your business grows.',
  },
  {
    id: 4,
    icon: 'Truck',
    title: 'Pan India Fast Delivery',
    description: 'Reliable logistics network. Orders dispatched within 24–48 hours.',
  },
  {
    id: 5,
    icon: 'Headphones',
    title: 'Dedicated B2B Support',
    description: 'Personal account manager for your business. WhatsApp & phone support.',
  },
  {
    id: 6,
    icon: 'ShieldCheck',
    title: 'Quality Guaranteed',
    description: 'Every piece quality-checked before dispatch. Trusted by 500+ retailers.',
  },
];
